import { useEffect } from "react";
import ReactGA from "react-ga4";

import GrpcStyles from "./grpc-styles-css.module.css";
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  Stack,
  Flex,
  Link,
} from "@chakra-ui/react";
// import { Link } from "react-router-dom";
import { FaGithub } from "react-icons/fa";

import GrpcStreamingMap from "./GrpcStreamingMap";
import ClientRollingSection from "../LandingPage/LandingPageComponents/ClientRollingSection";
import YellowstoneFeatures from "./gRPCComponents/YellowstoneFeatuures";
import FaqSection from "./gRPCComponents/FaqSection";
import DedicatedSection from "./gRPCComponents/DedicatedSection";
import UtilityRollingGrpc from "./gRPCComponents/UtilityRollingGrpc";
import GRPCPricingSection from "./gRPCComponents/GRPCPricingSection";
import GrpcSampleProjects from "./gRPCComponents/GrpcSampleProjects";
import GRPCCalltoAction from "./gRPCComponents/GRPCCalltoAction";

const Grpcstreaming = () => {
  useEffect(() => {
    document.title = "Shyft | Solana gRPC geyser nodes, powered by Shredstreams";
    document.description = "Yellowstone geyser or Solana gRPC is the fastest way to stream transactions, accounts and block updates.  No credits, unlimited streaming, powered by Jito Shredtreams."
    ReactGA.send({
      hitType: "pageview",
      page: "/solana-yellowstone-grpc",
    });
  }, []);
  return (
    <>
      <Box
        as={"div"}
        position={"relative"}
        height={"100vh"}
        minH={{ base: "100vh", md: "800px" }}
        bgImage={"/assets/smokey-background.png"}
        backgroundRepeat={"no-repeat"}
        backgroundSize={"cover"}
      >
        <Stack position={"relative"} w="full">
          <Container maxW={"4xl"} position={"relative"} margin={"0 auto"}>
            <Stack
              as={Box}
              textAlign={"center"}
              pt={{ base: 20, md: 24, xl: "200px" }}
              position={"relative"}
              zIndex={"1"}
            >
              <Heading
                as={"h1"}
                fontWeight={700}
                fontSize={{ base: "4xl", md: "6xl" }}
                lineHeight={"110%"}
                mb={0}
                color={"#fff"}
                letterSpacing={{ base: 1, md: 2 }}
              >
                Solana{" "}
                <Text as="span" style={{ color: "brand.red" }}>
                  gRPC
                </Text>{" "}
                Nodes.{" "}
              </Heading>
              <Heading
                as={"h2"}
                fontWeight={700}
                fontSize={{ base: "4xl", md: "6xl" }}
                lineHeight={"110%"}
                mb={0}
                color={"#fff"}
                letterSpacing={{ base: 1, md: 2 }}
              >
                Fast & Reliable.
              </Heading>

              <Box pt={{ base: 4, md: 8 }}>
                <Text
                  as="h2"
                  color={"brand.grey"}
                  fontSize={{ base: "xs", md: "lg" }}
                  fontFamily={"body"}
                  fontWeight={400}
                  lineHeight={{ base: "1.2rem", md: "1.5rem" }}
                >
                  Stream Solana data at the lowest latency possible with 
                  Shyft’s network of worldwide gRPC nodes. No credits, 
                  no metering & unlimited streaming. Accelerated with Jito shreds 
                  for ultra fresh data.
                </Text>
              </Box>
              <Box as="div" className={`${GrpcStyles.button_group}`} pt={12}>
                <Button
                  as={"a"}
                  href="/dashboard/grpc"
                  target="_blank"
                  pt={"15px"}
                  pb={"10px"}
                  display={"block"}
                  size={"sm"}
                  // width={"28"}
                  height={"12"}
                  // maxW={"180px"}
                  w={{ base: "full", lg: "180px" }}
                  border={"1px solid"}
                  borderColor={"brand.red"}
                  bgColor={"brand.red"}
                  color={"brand.white"}
                  borderRadius={"full"}
                  textColor={"#fff"}
                  fontFamily={"heading"}
                  fontWeight={"400"}
                  _hover={{
                    bgColor: "brand.white",
                    color: "brand.red",
                    borderColor: "brand.white",
                    textDecoration: "none",
                  }}
                  mt={{ base: 2, md: 1, lg: 0 }}
                  textAlign={"center"}
                >
                  Start Streaming
                </Button>
                <Button
                  as={"a"}
                  href="https://docs.shyft.to/solana-grpc-shredstream/grpc-docs"
                  target="_blank"
                  pt={"15px"}
                  pb={"10px"}
                  display={"block"}
                  size={"sm"}
                  // width={"28"}
                  height={"12"}
                  // maxW={"300px"}
                  w={{ base: "full", lg: "180px" }}
                  border={"1px solid"}
                  borderColor={"brand.red"}
                  bgColor={"brand.black"}
                  color={"brand.white"}
                  borderRadius={"full"}
                  textColor={"#fff"}
                  fontFamily={"heading"}
                  fontWeight={"400"}
                  _hover={{
                    bgColor: "brand.red",
                    color: "brand.white",
                    textDecoration: "none",
                  }}
                  mt={{ base: 2, md: 1, lg: 0 }}
                  textAlign={"center"}
                >
                  Documentation
                </Button>
                <Button
                  as={"a"}
                  href="https://github.com/Shyft-to/solana-defi"
                  target="_blank"
                  size={{base: "sm",md: "sm"}}
                  w={{ base: "full", lg: "190px" }}
                  border={"1px solid"}
                  borderColor={"brand.red"}
                  bgColor={"brand.black"}
                  color={"brand.white"}
                  borderRadius={"full"}
                  textColor={"#fff"}
                  fontFamily={"heading"}
                  fontWeight={"400"}
                  
                  _hover={{
                    bgColor: "brand.red",
                    color: "brand.white",
                    textDecoration: "none",
                  }}
                  mt={{ base: 2, md: 1, lg: 0 }}
                  textAlign={"center"}
                  alignItems={"center"}
                  py={'23px'}
                  leftIcon={<FaGithub size={22}/>}
                >
                  Code Samples
                </Button>
              </Box>
            </Stack>
          </Container>
        </Stack>
      </Box>
      <Box>
        <ClientRollingSection inverse={true} />
      </Box>
      <Box as="section" pt={{base: 0, md: 12}} pb={{base: 4, md: 16}}>
        <YellowstoneFeatures />
      </Box>
      <Box as="section" pt={{base: 8, md: 12}} pb={{base: 2, md: 4}}>
        <GrpcStreamingMap />
      </Box>
      <Box pt={{base: 0, md: 4}} pb={{base: 8, md: 24}}>
        <DedicatedSection />
      </Box>
      <Box>
        <UtilityRollingGrpc inverse={true} />
      </Box>
      <Box pb={{base: 6, md: 12}} pt={{base: 16, md: 20}}>
        {/* <PricingStatic /> */}
        <GRPCPricingSection />
      </Box>
      
      <Box>
        {/* <SampleProjects /> */}
        <GrpcSampleProjects />
      </Box>
      <Box pt={{base: 4, md: 0}} pb={{base: 6, md: 6}}>
        <FaqSection />
      </Box>
      <Box>
        {/* <Ready2Shyft /> */}
        <GRPCCalltoAction />
      </Box>
    </>
  );
};

export default Grpcstreaming;
